import Vue from 'vue'
import store from '@/store/store'
import * as Sentry from '@sentry/vue'

const sentryService = {
  init (Vue, store) {
    Sentry.init({
      Vue: Vue,

      dsn: window.sentry['dsn'] || '',
      environment: window.sentry['environment'] || 'undefined',
      release: window.sentry['release'] || '',
      tracesSampleRate:
        parseFloat(new URL(window.location).searchParams.get('traceme')) || window.sentry['tracesSampleRate'] || 0.1,
      tracingOptions: {
        trackComponents: true
      },
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.globalHandlersIntegration(),
        Sentry.browserApiErrorsIntegration(),
        Sentry.captureConsoleIntegration(),
        Sentry.breadcrumbsIntegration(),
        Sentry.replayIntegration({
          maskAllInputs: false,
          maskAllText: false,
          blockAllMedia: false
        })
      ],
      replaysSessionSampleRate: parseFloat(new URL(window.location).searchParams.get('traceme')) || window.sentry['tracesSampleRate'] || 0.1,
      replaysOnErrorSampleRate: parseFloat(new URL(window.location).searchParams.get('traceme')) || window.sentry['tracesSampleRate'] || 1
    })

    store.watch(
      state => state.user.user_data,
      userData => {
        if (userData.user_id !== undefined) {
          Sentry.setUser({
            id: userData.user_id
          })
        }
      }
    )
  }
}

export const setupSentryService = () => {
  if (window.sentry && +process.env.VUE_APP_SENTRY_ENABLED) {
    sentryService.init(Vue, store)
  }
}
